import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';
import { AnimationProp } from '@fortawesome/angular-fontawesome';
import { IconComponent } from '@libs/components/icons';
import { ButtonType } from '@libs/common/models';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';

@Component({
  selector: 'ui-toolbar-button',
  templateUrl: './toolbar-button.component.html',
  styleUrl: './toolbar-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButton,
    MatTooltip,
    IconComponent,
  ],
})
export class ToolbarButtonComponent {
  public clicked: OutputEmitterRef<void> = output();

  public type: InputSignal<ButtonType> = input<ButtonType>('button');
  public disabled: InputSignal<boolean> = input<boolean>(false);
  public icon: InputSignal<IconName> = input.required();
  public iconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('solid');
  public tooltipPosition: InputSignal<TooltipPosition> = input<TooltipPosition>('below');
  public tooltip: InputSignal<string> = input<string>('');
  public loading: ModelSignal<boolean> = model<boolean>(false);

  public currentAnimationName: Signal<AnimationProp | undefined> = computed(() => {
    return this.loading() ? 'spin' : undefined;
  });

  public currentIconName: Signal<IconName> = computed(() => {
    return this.loading() ? 'spinner-third' : this.icon();
  });

  public currentIconStyle: Signal<ComponentsIconsStyle> = computed(() => {
    return this.loading() ? 'light' : this.iconStyle();
  });
}
